import { ref } from '@nuxtjs/composition-api'
import { IRemoteConfigObject } from './remoteConfig.types'

export const remoteConfigObject = ref<IRemoteConfigObject>()
export const remoteConfigLoaded = ref(false)
